import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { IBuilderTime } from '@shared/interfaces';

@Component({
  selector: 'app-time',
  templateUrl: './time.component.html',
  styleUrls: ['./time.component.scss'],
  standalone: false,
})
export class TimeComponent implements OnInit {
  @Input() time: IBuilderTime;
  @Input() control: FormControl;
  @Output() valueChange = new EventEmitter<any>();

  today: Date = new Date();

  ngOnInit(): void {
    if (this.time.isRequired) {
      this.control.setValidators([Validators.required]);
    }

    // Default value as current date
    if (this.time.disallowCurrentTime && !this.control.value) {
      this.control.setValue(this.today);
    }

    // Update validators based on restrictions
    if (this.time.isFutureTimeSelected) {
      this.control.setValidators([
        ...(this.control.validator ? [this.control.validator] : []),
        (control) =>
          control.value && control.value < this.today
            ? { pastDateNotAllowed: true }
            : null,
      ]);
    }

    if (this.time.isPastTimeSelected) {
      this.control.setValidators([
        ...(this.control.validator ? [this.control.validator] : []),
        (control) =>
          control.value && control.value > this.today
            ? { futureDateNotAllowed: true }
            : null,
      ]);
    }

    this.control.updateValueAndValidity();

    // Emit whenever value changes
    this.control.valueChanges.subscribe((val) => {
      this.valueChange.emit(val);
    });
  }
}
